import $ from 'jquery'
import View from 'view/view'
import ModalView from 'component/modal/modal'

const PrintGuestlistModalView = View.extend({
    events: {
        'click .js-guestlist-print': '_onPrintButtonClick',
    },

    _onPrintButtonClick(event) {
        window.location.href = $(event.target).data('href')
    },
})

const PrintGuestlistView = View.extend({
    initialize() {
        const url = this.options.url

        const modal = this.initSubview(ModalView, {
            fullHeight: true,
            classes: 't-modal modal',
            url,
        })

        modal.once('Modal:opened', (payload) => {
            this.initSubview(PrintGuestlistModalView, {
                el: payload.container,
                parent: modal,
            })
        })
    },
})

export default PrintGuestlistView
